<template>
  <div class="page-container">
    <div class="yn-biz-header">
      <span class="yn-biz-title">项目照片</span>
      <div class="header-actions">
        <el-select v-model="xmid" size="mini" placeholder="选择项目" filterable clearable @change="loadPhotos" style="width:300px">
          <el-option v-for="p in projects" :key="p.id" :label="p.xmmc" :value="p.id" />
        </el-select>
      </div>
    </div>

    <template v-if="xmid">
      <el-tabs v-model="activeTab" @tab-click="loadPhotos">
        <el-tab-pane label="仪器检测照片" name="ticket">
          <div class="toolbar">
            <el-upload
              :action="uploadUrl"
              :data="{xmid, fjlxl: 'ticket', cjr_xm: user.xm}"
              :headers="{Authorization: ''}"
              :show-file-list="false"
              :on-success="onUploadSuccess"
              :on-error="onUploadError"
              accept="image/*"
              multiple>
              <el-button type="primary" icon="el-icon-plus">上传照片</el-button>
            </el-upload>
          </div>

          <div v-if="ticketPhotos.length" class="photo-preview">
            <div class="a4-grid">
              <div v-for="p in ticketPhotos" :key="p.id" class="photo-card">
                <div class="photo-img-wrapper">
                  <el-image :src="photoUrl(p.wjlj)" fit="contain" class="photo-img" :preview-src-list="previewList(ticketPhotos)"></el-image>
                </div>
                <div class="photo-info">
                  <span class="photo-name">{{ p.wjmc }}</span>
                  <el-button type="text" size="mini" icon="el-icon-delete" class="photo-del" @click="delPhoto(p)"></el-button>
                </div>
              </div>
            </div>
          </div>
          <el-empty v-else-if="loaded" description="暂无仪器照片"></el-empty>
        </el-tab-pane>

        <el-tab-pane label="现场照片" name="site">
          <div class="toolbar">
            <el-upload
              :action="uploadUrl"
              :data="{xmid, fjlxl: 'site', cjr_xm: user.xm}"
              :headers="{Authorization: ''}"
              :show-file-list="false"
              :on-success="onUploadSuccess"
              :on-error="onUploadError"
              accept="image/*"
              multiple>
              <el-button type="primary" icon="el-icon-plus">上传照片</el-button>
            </el-upload>
          </div>

          <div v-if="sitePhotos.length" class="photo-preview">
            <div class="site-grid">
              <div v-for="p in sitePhotos" :key="p.id" class="site-card">
                <div class="site-img-wrapper">
                  <el-image :src="photoUrl(p.wjlj)" fit="contain" class="site-img" :preview-src-list="previewList(sitePhotos)"></el-image>
                </div>
                <div class="photo-info">
                  <span class="photo-name">{{ p.wjmc }}</span>
                  <el-button type="text" size="mini" icon="el-icon-delete" class="photo-del" @click="delPhoto(p)"></el-button>
                </div>
              </div>
            </div>
          </div>
          <el-empty v-else-if="loaded" description="暂无现场照片"></el-empty>
        </el-tab-pane>
      </el-tabs>
    </template>
    <el-empty v-else description="请先选择项目"></el-empty>
  </div>
</template>

<script>
import api from '@/utils/api'

export default {
  name: 'PhotoManage',
  data() {
    return {
      xmid: '',
      activeTab: 'ticket',
      projects: [],
      ticketPhotos: [],
      sitePhotos: [],
      loaded: false
    }
  },
  computed: {
    uploadUrl() {
      return '/yn_api.php?yn_xmfj_upload=1'
    },
    user() {
      return JSON.parse(sessionStorage.getItem('yn_user') || '{}')
    }
  },
  mounted() {
    this.loadProjects()
    const q = this.$route.query
    if (q.xmid) {
      this.xmid = q.xmid
      this.loadPhotos()
    }
  },
  methods: {
    async loadProjects() {
      const res = await api.get('yn_xm_list')
      if (res.data) this.projects = res.data
    },
    async loadPhotos() {
      if (!this.xmid) return
      this.loaded = false
      const res = await api.get('yn_xmfj_list', { xmid: this.xmid, fjlxl: 'ticket' })
      if (res.data) this.ticketPhotos = res.data

      const res2 = await api.get('yn_xmfj_list', { xmid: this.xmid, fjlxl: 'site' })
      if (res2.data) this.sitePhotos = res2.data
      this.loaded = true
    },
    photoUrl(path) {
      if (!path) return ''
      return 'http://bg.yasenkj.cn/' + path.replace(/\\/g, '/')
    },
    previewList(photos) {
      return photos.map(p => this.photoUrl(p.wjlj))
    },
    onUploadSuccess(res) {
      if (typeof res === 'string' && res.startsWith('22')) {
        this.$message.error('上传失败')
        return
      }
      this.$message.success('上传成功')
      this.loadPhotos()
    },
    onUploadError() {
      this.$message.error('上传失败')
    },
    delPhoto(p) {
      this.$confirm('确认删除?', '提示').then(async () => {
        const res = await api.post('yn_xmfj_del', { id: p.id })
        if (res.data === '11') {
          this.$message.success('已删除')
          this.loadPhotos()
        } else {
          this.$message.error('删除失败')
        }
      }).catch(() => {})
    },
  }
}
</script>

<style scoped>
.toolbar {
  display: flex; gap: 12px; align-items: center; margin-bottom: 16px;
}
.photo-preview {
  background: #fff; border-radius: 4px; padding: 16px;
}
.a4-grid {
  display: grid; grid-template-columns: repeat(4, 1fr); gap: 12px;
}
.photo-card {
  border: 1px solid #e8e8e8; border-radius: 4px; overflow: hidden; background: #fafafa;
}
.photo-img-wrapper {
  height: 180px; display: flex; align-items: center; justify-content: center; padding: 8px;
}
.photo-img {
  max-width: 100%; max-height: 100%;
}
.photo-info {
  display: flex; align-items: center; justify-content: space-between; padding: 6px 10px; background: #fff; border-top: 1px solid #f0f0f0;
}
.photo-name {
  font-size: 12px; color: #666; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; flex: 1;
}
.photo-del {
  color: #f56c6c !important; flex-shrink: 0;
}
.site-grid {
  display: flex; flex-direction: column; gap: 16px;
}
.site-card {
  border: 1px solid #e8e8e8; border-radius: 4px; overflow: hidden;
}
.site-img-wrapper {
  display: flex; align-items: center; justify-content: center; padding: 16px; background: #fafafa;
}
.site-img {
  max-width: 100%; max-height: 600px;
}
</style>
